import { useState } from 'react';


export default function Survey(){
  const [imie, setImie] = useState("");
  const [nazwisko, setNazwisko] = useState("");
  const [plec, setPlec] = useState("");
  const [zainteresowania, setZainteresowania] = useState([]);
  const [szkola, setSzkola] = useState("");
  const [oSobie, setOSobie] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
  }

  const handlePlecChange = (event) => {
    setPlec(event.target.value);
  };

  const handleZainteresowaniaChange = (event) => {
    const { value, checked } = event.target;
    
    // If checked, add the option to the zainteresowania array
    if (checked) {
      setZainteresowania((prevOptions) => [...prevOptions, value]);
    } else {
      // If unchecked, remove the option from the zainteresowania array
      setZainteresowania((prevOptions) => 
        prevOptions.filter((option) => option !== value)
      );
    }
  };

  const handleSzkolaChange = (event) => {
    setSzkola(event.target.value);
  };

  
  const handleOSobieChange = (event) => {
    setOSobie(event.target.value);
  };

   // Reset the form to its initial state
   const handleReset = () => {
    setImie("");
    setNazwisko("");
    setOSobie("");
    setPlec("");
    setSzkola("");
    setZainteresowania([]);
  };

  return (
    <div>
    <form onSubmit={handleSubmit}>
      <h1>Ankieta</h1>
      <label>
        <input 
          type="text" 
          id="imie"
          value={imie}
          onChange={(e) => setImie(e.target.value)}
        />
        imię
      </label>
      <br />
      <label>
        <input 
          type="text" 
          id="nazwisko"
          value={nazwisko}
          onChange={(e) => setNazwisko(e.target.value)}
        />
        nazwisko
      </label>
      <br />
      <h3>płeć</h3>
      <label>
        <input
          type="radio"
          value="mężczyzna"
          checked={plec === 'mężczyzna'}
          onChange={handlePlecChange}
        />
        mężczyzna
      </label>
      <label>
        <input
          type="radio"
          value="kobieta"
          checked={plec === 'kobieta'}
          onChange={handlePlecChange}
        />
        kobieta
      </label>
     
     <h3>zainteresowania</h3>
     <label>
        <input
          type="checkbox"
          value="sport"
          checked={zainteresowania.includes('sport')}
          onChange={handleZainteresowaniaChange}
        />
        sport
      </label>
      <label>
        <input
          type="checkbox"
          value="film"
          checked={zainteresowania.includes('film')}
          onChange={handleZainteresowaniaChange}
        />
        film
      </label>
      <label>
        <input
          type="checkbox"
          value="elektronika"
          checked={zainteresowania.includes('elektronika')}
          onChange={handleZainteresowaniaChange}
        />
        elektronika
      </label>
      <label>
        <input
          type="checkbox"
          value="informatyka"
          checked={zainteresowania.includes('informatyka')}
          onChange={handleZainteresowaniaChange}
        />
        informatyka
      </label>
      <br />
    

     <h3>szkoła</h3>
     <select value={szkola} onChange={handleSzkolaChange}>
      <option >wybierz</option>
      <option value="podstawowa">Podstawowa</option>
      <option value="CKZiU">CKZiU</option>
      <option value="liceum">liceum</option>
      <option value="politechnika">Politechnika Łódzka</option>
      <option value="uniwersytet">Uniwersytet Łódzki</option>
      <option value="inna">inna</option>
     </select>

     <h3>krótko o sobie</h3>

     <textarea
        value={oSobie}
        onChange={handleOSobieChange}
        rows="5"
        cols="30"
        placeholder="Kilka słów o sobie..."
      >
      </textarea>
      <br />
      <input type="button" onClick={handleReset} value="reset" />
    </form>
    <hr />
    <div>
        <h3>Twoje dane:</h3>
        <p> 
            imię: {imie || 'brak'}<br />
            nazwisko: {nazwisko || 'brak'}<br />
            płeć: {plec || 'brak'}<br />
            zainteresowania: {zainteresowania.length > 0 ? zainteresowania.join(', ') : 'brak'}<br />
            szkoła: {szkola || 'brak'}<br />
            o sobie: {oSobie || 'brak'}
        </p>
        
      </div>
    </div>
  )
}
